import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminSupportTicket,
  SupportTicketMessage,
  SupportTicketStatus,
} from '../../shared/interfaces';
import { API_BASE_URL } from '../../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';

/** Support inbox endpoints, available to system admins only */
@Injectable({ providedIn: 'root' })
export class SupportAdminService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private get ticketsUrl() {
    return `${this.baseUrl}/api/v1/system-admin/support/tickets`;
  }

  private get authContext() {
    return { context: new HttpContext().set(REQUIRE_AUTH, true) };
  }

  listTickets(search?: string): Observable<AdminSupportTicket[]> {
    const params: Record<string, string> = {};
    if (search?.trim()) params['search'] = search.trim();
    return this.http.get<AdminSupportTicket[]>(this.ticketsUrl, { ...this.authContext, params });
  }

  listMessages(ticketId: string): Observable<SupportTicketMessage[]> {
    return this.http.get<SupportTicketMessage[]>(`${this.ticketsUrl}/${ticketId}/messages`, this.authContext);
  }

  reply(
    ticketId: string,
    body: string,
    status: Extract<SupportTicketStatus, 'in_progress' | 'waiting_user' | 'resolved'>
  ): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.ticketsUrl}/${ticketId}/messages`, { body, status }, this.authContext);
  }

  changeStatus(ticketId: string, status: SupportTicketStatus): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(`${this.ticketsUrl}/${ticketId}/status`, { status }, this.authContext);
  }
}
